<template>
	<!--
		A password box with the design's text toggle (GÖSTER / GİZLE) in place of Buefy's
		eye icon. The toggle is a real button, so it is reachable from the keyboard, which
		the icon was not. Everything else (v-model, @input, autocomplete, required) passes
		straight to the b-input, and the enclosing b-field still colours it on an error.
	-->
	<div class="password-input">
		<b-input v-bind="$attrs"
				 :type="shown ? 'text' : 'password'"
				 :status-icon="false"
				 v-on="$listeners"></b-input>
		<button type="button"
				class="password-toggle"
				:aria-pressed="shown ? 'true' : 'false'"
				@click="shown = !shown">
			{{ shown ? $lang.Password.Hide : $lang.Password.Show }}
		</button>
	</div>
</template>

<script>
	export default {
		name: 'PasswordInput',
		inheritAttrs: false,
		data() {
			return { shown: false };
		}
	};
</script>
